import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-axylog-detail-popup',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './axylog-detail-popup.component.html',
  styleUrls: ['./axylog-detail-popup.component.css']
})
export class AxylogDetailPopupComponent implements OnInit, OnChanges {
  @Input() visible = false;
  @Input() selectedWaybillCodes: string[] = [];
  @Output() confirmed = new EventEmitter<{ waybillCodes: string[] }>();
  @Output() closed = new EventEmitter<void>();

  // Local copy of waybill codes that can be modified
  localWaybillCodes: string[] = [];
  
  // Loading state for the send button
  isSending = false;

  ngOnInit(): void {
    // Initialize local copy
    this.resetForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      if (changes['visible'].currentValue === true) {
        // Popup diventa visibile - forza il reset
        console.log('Axylog popup becoming visible, forcing reset');
        // Svuota tutto prima di resettare
        this.localWaybillCodes = [];
        this.isSending = false;
        // Poi ricarica con i nuovi dati
        setTimeout(() => this.resetForm(), 0);
      } else if (changes['visible'].currentValue === false && changes['visible'].previousValue === true) {
        // Popup diventa invisibile - forza la pulizia
        console.log('Axylog popup becoming invisible, forcing cleanup');
        this.localWaybillCodes = [];
        this.isSending = false;
      }
    }
  }

  resetForm(): void {
    // Forza sempre il reset completo con le nuove bolle selezionate
    this.localWaybillCodes = [...this.selectedWaybillCodes];
    this.isSending = false;
    console.log('Axylog popup reset with waybills:', this.localWaybillCodes);
  }

  removeWaybill(waybillCode: string): void {
    this.localWaybillCodes = this.localWaybillCodes.filter(code => code !== waybillCode);
  }

  onConfirm(): void {
    if (this.localWaybillCodes.length === 0) {
      return; // Non permettere la conferma se non ci sono bolle
    }

    this.isSending = true;

    const data = {
      waybillCodes: this.localWaybillCodes
    };
    
    this.confirmed.emit(data);
    this.close();
  }

  close(): void {
    this.visible = false;
    // Svuota completamente i dati alla chiusura
    this.localWaybillCodes = [];
    this.isSending = false;
    console.log('Axylog popup closed and cleared');
    this.closed.emit();
  }

  onBackdropClick(event: Event): void {
    // Close popup only if clicking on backdrop, not on content
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  /**
   * TrackBy function for ngFor optimization
   */
  trackByWaybillCode(index: number, waybillCode: string): string {
    return waybillCode;
  }
}
